import React, { FC } from "react";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import Schedule from "../schedule";
import { useFormikContext } from "formik";
import { WizardStepLayout } from "../../../../components/wizard/wizard-summary-layout";

interface ScheduleStepProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
}

const ScheduleStep: FC<ScheduleStepProps> = ({ onNext, onBack }) => {
    const { translate } = useLocale();
    const { isValid } = useFormikContext<any>();
    
    return (
        <WizardStepLayout onBack={onBack} onNext={onNext} nextDisabled={!isValid}>
            <div className="pl-5 overflow-y-auto overflow-x-hidden">
                <Schedule />
            </div>
        </WizardStepLayout>
    );
};

export default ScheduleStep;
